import Vue from 'vue'
import VueGtm from 'vue-gtm'
import Router from 'vue-router'
import step1 from '@/views/step1.vue'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Step1',
      component: step1
    },
    {
      path: '/auth',
      name: 'Step1 Auth',
      component: () => import('@/views/auth.vue'),
      props: true,
      beforeEnter(to, from, next) {
        if (store.state.creditConsent) {
          next()
        } else {
          next('/')
        }
      }
    },
    {
      path: '/complete',
      name: 'Complete',
      component: () => import('@/views/complete.vue'),
      props: true,
      beforeEnter(to, from, next) {
        if (store.state.creditScore) {
          next()
        } else {
          next('/')
        }
      }
    }
  ]
})

/* eslint-disable */
Vue.use(VueGtm, {
  id: 'GTM-PVH58B2', // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
})
/* eslint-disable */

/* eslint-disable */
// router.afterEach((to) => {
//   if (process.env.NODE_ENV === 'production') {
//     gtag('config', 'UA-23691971-1', {
//       'page_path': to.path
//     });
//   }
// });
/* eslint-enable */

export default router
